module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAe1BMVEUAAAAAAAAAZswAVaoAXdEAVb8RVbsOVbgLYL8QYL8RY78RZMIPYcIRY8IRY8ARZb8SZMESY8ATY8ATZcESY8ASY8AUZL8TZMATY78TZL8TZMATZcATZMATZL8UZcAUZMAUZMATZcATZcAUZcATZb8UZcATZL8TZMAUZcClODxYAAAAKHRSTlMAAQUGCwwPEhggLC4yO01YZnF2d36NnKOssLO5uszP0dna3+nw9vz+g27XkwAAAHZJREFUGBm1wQsCQkAUBdArfZj8C1GkqO7+V9ibPLGAOgd/tE7KqohXWIp6Wl2AWfTkaDCYbHqSjzNF40AlFK1PK4QqKVqfVgZVUVy3N4ocqqB4HXcXkilUzI/TnqSBcjtOanwFA0d3DzPT0Ko9LDnhIU8NfuINs2wRexM2zIEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-hous.png
// module id = LXqz
// module chunks = 1